<script lang="ts">
	import { page } from '$app/stores';
	import homeImg from '$lib/assets/images/home.webp';
	import __ from '$lib/stores/TranslationStore';
	import Cta from '../Global/Cta.svelte';

	const title = $__('Damos as boas&#8209vindas à poupança do nosso tempo.');
	const caption = $__(
		'Somos um intermediário de créditos e mediador de seguros que escolheu um lado: o das pessoas que querem poupar.'
	);
	const cta = $__('Quero poupar');
</script>

<div class="hidden h-[600px] w-full justify-center bg-light xl:flex">
	<section class="flex w-2/5 items-center justify-center px-10 pl-[3rem] lg:pl-[2rem]">
		<div class="flex w-1/2 flex-col gap-y-9 text-dark">
			<h1 class="text-4xl font-semibold">{@html title}</h1>
			<h3 class="text-lg">{caption}</h3>
			<Cta class="justify-center text-xl" type="anchor" props={{ href: '/simuladores' }}>
				{cta}
			</Cta>
		</div>
	</section>
	<div class="w-3/5 self-stretch">
		<img src={homeImg} class="h-full w-full object-cover object-bottom" alt="" loading="lazy" />
		<!-- <Image src={homeImg} alt="" class="block h-full" loading="lazy" /> -->
	</div>
</div>

<div
	class="h-[calc(100dvh - 68px)] flex items-center justify-center bg-cover bg-center bg-no-repeat px-4 mix-blend-multiply xl:hidden"
	style="background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 20%, rgba(0, 0, 0, 0.8) 75%), url({homeImg})"
>
	<div class="mx-auto flex max-w-sm flex-col gap-y-6 px-8 pb-16 pt-40">
		<h2
			class="whitespace hyphens-none text-4xl/9 font-semibold text-white xl:text-5xl xl:text-dark"
		>
			{@html title}
		</h2>
		<h3 class="text-xl text-white">
			{caption}
		</h3>
		<Cta
			type="anchor"
			props={{ href: '/simuladores' }}
			class="w-full justify-center bg-primary-light px-8 py-3 text-nav-button font-semibold leading-nav-button text-dark md:border-0"
		>
			{cta}
		</Cta>
	</div>
</div>
